import httpClient from "@/http";
import axios from "axios";

export const EventStatisticsMixin = {
    props: {
        commonQueryParams: { type: Object, default: () => { return {} } }
    },
    data() {
        return {
            url: '/statistics/events/count',
            chartData: {
                labels: null,
                datasets: []
            },
            chartDataInitialized: false,
            breakdownType: 1,
            fetchError: false,
            cancelTokenSource: null
        }
    },
    methods: {
        onBreakdownTypeChange() {
            this.$emit('breakdown-changed', this.breakdownType)
            // await this.fetch()
        },

        getBreakdownType() {
            return this.breakdownType
        },

        async fetch() {
            if (this.cancelTokenSource) {
                this.cancelTokenSource.cancel('DataTable query set');
                this.cancelTokenSource = null;
            }

            const vm = this;
            let url = vm.url;

            vm.chartDataInitialized = false;
            vm.fetchError = false;
            vm.chartData.labels = [];
            vm.chartData.datasets = [];

            let extraParams = vm.getExtraParams();

            for (const params of extraParams) {
                if (params['url']) {
                    url = params['url']
                }
                let queryParams = {...vm.commonQueryParams, ...params.query};
                queryParams['breakdown'] = vm.breakdownType;

                vm.cancelTokenSource = axios.CancelToken.source()

                let resultData = {};
                try {
                    resultData = await httpClient.get(url, {
                        params: queryParams,
                        cancelToken: vm.cancelTokenSource.token
                    });
                } catch (reason) {
                    if (axios.isCancel(reason)) {
                        vm.chartDataInitialized = false;
                        return
                    } else {
                        vm.fetchError = true
                        vm.$emit('fetch-failed');
                        return
                    }
                }
                if (vm.chartData.labels.length === 0 && resultData.data) {
                    vm.chartData.labels = [...resultData.data['data']['x_labels']]
                }
                let backgroundColor = params.backgroundColor;
                if (vm.hasOwnProperty('getBackgroundColors')) {
                    const backgroundColors = vm.getBackgroundColors();
                    if (backgroundColors && backgroundColors.length > 0) {
                        backgroundColor = backgroundColors
                    }
                }
                let dataset = {
                    data: resultData.data['data']['data'],
                    label: params.label,
                    filterLabel: params.filterLabel,
                    borderColor: params.borderColor,
                    backgroundColor: backgroundColor,
                    rowParams: queryParams,
                    colParams: resultData.data['data']['data_extra']
                }
                console.log(resultData.data['data']['data_extra'])
                if (params['url']) {
                    dataset['disabled'] = true
                }
                if (!backgroundColor) {
                    dataset['backgroundColor'] = 'transparent'
                }
                vm.chartData.datasets.push(dataset)
            }
            vm.chartData = {...vm.chartData}
            vm.chartDataInitialized = true;
        }
    }
}